export default __webpack_public_path__ + "static/media/404.38ba9f95.jpg";